import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { formatPrice } from "../i18n/translations";

const ORDER_EMAIL = "luxerakalima@gmail.com";

const CheckoutPage = () => {
  const { cart, products, currency, cartSubtotal } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", firstName: "", lastName: "", address: "", city: "", postal: "", country: "Germany" });
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const orderId = "REQ-" + Date.now().toString(36).toUpperCase();
    const lines = cart.map((item) => {
      const p = products.find((p) => p.id === item.product_id);
      if (!p) return null;
      return `- ${p.name} x${item.quantity} — ${formatPrice(p.price * item.quantity, currency)}`;
    }).filter(Boolean).join("%0D%0A");
    const body =
      `Order request ${orderId}%0D%0A%0D%0A` +
      `${lines}%0D%0A%0D%0ATotal: ${formatPrice(cartSubtotal, currency)}%0D%0A%0D%0A` +
      `Customer:%0D%0A${form.firstName} ${form.lastName}%0D%0A${form.address}, ${form.city} ${form.postal}, ${form.country}%0D%0AEmail: ${form.email}`;
    window.location.href = `mailto:${ORDER_EMAIL}?subject=New order request ${orderId}&body=${body}`;
    setSubmitting(false);
    nav(`/order-confirmation/${orderId}`);
  };

  return (
    <main className="py-16" data-testid="checkout-page">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <h1 className="font-display text-4xl lg:text-5xl mb-12 text-center">Checkout</h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <form onSubmit={onSubmit} className="space-y-5" data-testid="checkout-form">
            <h2 className="font-display text-2xl mb-2">Contact</h2>
            <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none focus:border-[var(--noir)]" data-testid="checkout-email" />
            <h2 className="font-display text-2xl mt-8 mb-2">Shipping</h2>
            <div className="grid grid-cols-2 gap-3">
              <input required placeholder="First name" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} className="border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none" />
              <input required placeholder="Last name" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} className="border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none" />
            </div>
            <input required placeholder="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none" />
            <div className="grid grid-cols-2 gap-3">
              <input required placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none" />
              <input required placeholder="Postal code" value={form.postal} onChange={(e) => setForm({ ...form, postal: e.target.value })} className="border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none" />
            </div>
            <input required placeholder="Country" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 text-sm bg-white outline-none" />

            <button type="submit" disabled={submitting || cart.length === 0} className="btn-lux w-full bg-[var(--noir)] text-[var(--ivory)] py-4 text-[11px] tracking-[0.25em] uppercase hover:text-[var(--gold)] disabled:opacity-50" data-testid="checkout-submit">
              {submitting ? "Processing..." : "Send Order Request"}
            </button>
            <p className="text-[11px] text-[var(--grey)] text-center">No online payment yet — we'll contact you by email to confirm your order and arrange payment.</p>
          </form>

          <aside className="bg-[var(--ivory-deep)] p-8 h-fit">
            <h2 className="font-display text-2xl mb-6">Your Order</h2>
            <div className="space-y-4 divide-y divide-[var(--champagne)]/60">
              {cart.map((item) => {
                const p = products.find((p) => p.id === item.product_id);
                if (!p) return null;
                return (
                  <div key={item.product_id} className="flex gap-4 pt-4">
                    <img src={p.images[0]} alt="" className="w-14 h-16 object-cover" />
                    <div className="flex-1 text-sm">
                      <div className="font-serif">{p.name}</div>
                      <div className="text-xs text-[var(--grey)]">Qty {item.quantity}</div>
                    </div>
                    <div className="text-sm">{formatPrice(p.price * item.quantity, currency)}</div>
                  </div>
                );
              })}
            </div>
            <div className="border-t border-[var(--champagne)] mt-6 pt-4 flex justify-between font-serif text-xl">
              <span>Total</span>
              <span>{formatPrice(cartSubtotal, currency)}</span>
            </div>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default CheckoutPage;
